import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { LogIn, LogOut, User } from 'lucide-react';
import { upsertUserProfile } from '../utils/supabaseHelpers';

const Login = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const getSession = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();

      const currentUser = session?.user ?? null;
      setUser(currentUser);

      if (currentUser) {
        await upsertUserProfile(currentUser); // ✅ Corrected: pass user to helper
      }
    };

    getSession();

    const { data: listener } = supabase.auth.onAuthStateChange(
      async (_event, session) => {
        const currentUser = session?.user ?? null;
        setUser(currentUser);

        if (currentUser) {
          await upsertUserProfile(currentUser); // ✅ Also fix here
          navigate('/upload'); // ✅ Redirect after login
        }
      }
    );

    return () => {
      listener.subscription.unsubscribe();
    };
  }, [navigate]);

  const handleGoogleLogin = async () => {
    const redirectUrl = `${window.location.origin}/upload`; // ✅ Environment-safe

    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: redirectUrl,
      },
    });

    if (error) {
      console.error('Google login error:', error.message);
    }
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-100 to-purple-100 flex items-center justify-center px-4">
      <div className="bg-white/80 backdrop-blur-md shadow-2xl rounded-2xl p-10 max-w-md w-full text-center">
        <img
          src="/logo-full.png"
          alt="JobZam Full Logo"
          className="w-32 mx-auto mb-4"
        />

        <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 mb-2">
          Welcome to JobZam
        </h1>
        <p className="text-sm text-gray-600 mb-6">Your AI-powered job hunt assistant 🤖✨</p>

        {!user ? (
          <button
            onClick={handleGoogleLogin}
            className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full shadow-md transition"
          >
            <LogIn className="w-5 h-5" />
            Sign in with Google
          </button>
        ) : (
          <>
            <div className="flex items-center justify-center gap-2 mb-4 text-blue-700 font-semibold text-sm">
              <User className="w-4 h-4" />
              {user.email}
            </div>
            <button
              onClick={handleLogout}
              className="flex items-center justify-center gap-2 bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-full shadow-md transition text-sm"
            >
              <LogOut className="w-4 h-4" />
              Logout
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;
